import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tree = _resolveComponent("el-tree")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createBlock(_component_el_select, {
    ref: "selectRef",
    modelValue: _ctx.componentLabel,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.componentLabel) = $event)),
    clearable: "",
    onClear: _ctx.handleClear
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_option, {
        value: _ctx.componentValue,
        style: {"height":"auto","padding":"0"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_tree, _mergeProps({
            ref: "selectTreeRef",
            "highlight-current": "",
            data: _ctx.treeData
          }, _ctx.treeOptions, { onNodeClick: _ctx.handleCheckChange }), null, 16, ["data", "onNodeClick"])
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    _: 1
  }, 8, ["modelValue", "onClear"]))
}